import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';
import { FiltersContainer } from '../FiltersContainer';
import './App.css';
import { AllFiltersContainer } from '../AllFiltersContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    microfrontendsRegistry,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <MicrofrontendProvider registry={microfrontendsRegistry}>
              <FiltersContainer />
              <AllFiltersContainer />
            </MicrofrontendProvider>
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
